(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["graph"] && !Shopify.designMode) return;
  try {
    
  if ('customElements' in window && !customElements.get('epz-frequency-response')) {
    class EPZFrequencyResponse extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const start = () => {
          if (!this.isConnected || this.ready) return;
          this.initialize(signal);
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true, signal });
        } else if (this.querySelector('.epz-fr__inner')) {
          // Editor fragments already contain their children. Bind before block selection fires.
          start();
        } else {
          this.frame = requestAnimationFrame(start);
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.controller = null;
        this.ready = false;
      }

      initialize(signal) {
        this.ready = true;
        this.notes = [...this.querySelectorAll('[data-fr-note]')];
        this.controls = [...this.querySelectorAll('[data-fr-select]')];
        this.markers = [...this.querySelectorAll('[data-fr-marker]')];
        this.guides = [...this.querySelectorAll('[data-fr-guide]')];
        this.nav = this.querySelector('[data-fr-nav]');
        this.rail = this.querySelector('.epz-fr__rail');
        this.guideLayer = this.querySelector('[data-fr-guides]');
        this.hint = this.querySelector('[data-fr-hint]');
        this.prompt = this.querySelector('[data-fr-prompt]');
        this.status = this.querySelector('[data-fr-status]');
        this.image = this.querySelector('.epz-fr__image');
        this.figure = this.querySelector('[data-fr-figure]');
        this.mobile = matchMedia('(max-width: 749px)');
        this.hover = matchMedia('(hover: hover) and (pointer: fine)');
        this.selected = null;
        this.interacted = false;
        this.editorSelected = null;
        this.enhanced = false;
        this.classList.remove('is-enhanced', 'has-interacted');

        // Never coerce blank, zero or malformed axis values into a plausible graph.
        const min = Number(this.dataset.minFrequency);
        const max = Number(this.dataset.maxFrequency);
        const left = Number(this.dataset.plotLeft);
        const right = Number(this.dataset.plotRight);
        const logMin = Math.log(min);
        const logSpan = Math.log(max) - logMin;
        const axisOK = [min, max, left, right, logSpan].every(Number.isFinite) && min > 0 && max > min && logSpan > 0 && left >= 0 && right >= 0 && left + right < 100;
        let invalidCount = 0;
        let validCount = 0;
        this.markers.forEach(marker => {
          const frequency = Number(marker.dataset.frequency);
          const valid = axisOK && Number.isFinite(frequency) && frequency >= min && frequency <= max;
          marker.hidden = !valid;
          const guide = this.guides.find(item => item.dataset.frGuide === marker.dataset.frSelect);
          if (guide) guide.hidden = !valid;
          if (!valid) { invalidCount += 1; return; }
          // X is relative to the whole image. Plot margins are shared by all blocks.
          const fraction = (Math.log(frequency) - logMin) / logSpan;
          const x = `${left + fraction * (100 - left - right)}%`;
          marker.style.setProperty('--fr-x', x);
          if (guide) guide.style.setProperty('--fr-x', x);
          validCount += 1;
        });
        const warning = this.querySelector('[data-fr-warning]');
        if (warning) warning.hidden = invalidCount === 0;

        this.addEventListener('click', event => {
          const control = event.target.closest('[data-fr-select]');
          if (!control || !this.contains(control) || !this.enhanced) return;
          this.select(control.dataset.frSelect, true, true);
        }, { signal });
        this.addEventListener('focusin', event => {
          const control = event.target.closest('[data-fr-select]');
          if (control && this.enhanced) this.select(control.dataset.frSelect, true, true);
        }, { signal });
        this.addEventListener('pointerover', event => {
          if (event.pointerType !== 'mouse' || this.mobile.matches || !this.hover.matches || !this.enhanced || this.editorSelected) return;
          if (this.notes.some(note => note.contains(document.activeElement))) return;
          const control = event.target.closest('[data-fr-select]');
          if (!control || control.contains(event.relatedTarget)) return;
          this.select(control.dataset.frSelect, false, true);
        }, { signal });
        this.addEventListener('keydown', event => this.onKeydown(event), { signal });
        this.mobile.addEventListener('change', () => {
          // Keep a focused link visible when a viewport change collapses mobile notes.
          const focusedNote = this.notes.find(note => note.contains(document.activeElement));
          if (focusedNote) this.selected = focusedNote.dataset.frNote;
          else if (!this.interacted && !this.editorSelected) this.setInitialSelection();
          this.update();
        }, { signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.layoutMarkers());
          if (this.rail) this.resizeObserver.observe(this.rail);
        } else {
          window.addEventListener('resize', () => this.layoutMarkers(), { signal });
        }

        if (this.hasAttribute('data-design-mode')) {
          this.addEventListener('shopify:block:select', event => {
            const id = event.detail?.blockId;
            if (!this.notes.some(note => note.dataset.frNote === id)) return;
            this.editorSelected = id;
            this.select(id, false, false);
            this.notes.find(note => note.dataset.frNote === id)?.scrollIntoView({ block: 'nearest', behavior: 'auto' });
          }, { signal });
          this.addEventListener('shopify:block:deselect', () => { this.editorSelected = null; }, { signal });
        }

        const reveal = () => {
          if (!this.isConnected) return;
          if (this.figure) this.figure.hidden = false;
          this.enhanced = Boolean(axisOK && this.image?.naturalWidth > 0 && this.notes.length);
          this.classList.toggle('is-enhanced', this.enhanced);
          if (this.rail) this.rail.hidden = !this.enhanced || validCount === 0;
          if (this.guideLayer) this.guideLayer.hidden = !this.enhanced || validCount === 0;
          if (this.nav) this.nav.hidden = !this.enhanced;
          if (this.hint) this.hint.hidden = !this.enhanced;
          if (!this.interacted && !this.editorSelected) this.setInitialSelection();
          this.update();
          this.layoutMarkers();
        };
        const imageFailed = () => {
          this.enhanced = false;
          this.classList.remove('is-enhanced');
          if (this.figure) this.figure.hidden = true;
          if (this.nav) this.nav.hidden = true;
          if (this.hint) this.hint.hidden = true;
          this.update();
        };
        if (this.image) {
          this.image.addEventListener('load', reveal, { signal });
          this.image.addEventListener('error', imageFailed, { signal });
          if (this.image.complete) {
            if (this.image.naturalWidth > 0) reveal();
            else imageFailed();
          } else {
            this.update();
          }
        } else {
          reveal();
        }
      }

      setInitialSelection() {
        const waitForTap = this.mobile.matches && this.dataset.mobileInitial === 'prompt' && this.dataset.mobileBehavior !== 'all';
        this.selected = waitForTap ? null : (this.notes[0]?.dataset.frNote || null);
      }

      layoutMarkers() {
        if (!this.enhanced || !this.rail || this.rail.hidden) return;
        const width = this.rail.clientWidth;
        if (width <= 0) return;
        // Stagger crowded 44px targets automatically, without altering frequency X.
        const rows = [];
        const markers = this.markers.filter(marker => !marker.hidden).sort((a, b) => Number(a.dataset.frequency) - Number(b.dataset.frequency));
        markers.forEach(marker => {
          const center = parseFloat(marker.style.getPropertyValue('--fr-x')) * width / 100;
          let row = rows.findIndex(rightEdge => center - 22 >= rightEdge + 4);
          if (row < 0) row = rows.length;
          rows[row] = center + 22;
          marker.style.setProperty('--fr-row', `${row * 44}px`);
        });
        this.rail.style.height = `${Math.max(1, rows.length) * 44 + 4}px`;
        this.rail.style.setProperty('--fr-rail-height', this.rail.style.height);
      }

      select(id, announce, interacted) {
        if (!this.notes.some(note => note.dataset.frNote === id)) return;
        if (this.editorSelected && id !== this.editorSelected) return;
        const changed = this.selected !== id;
        this.selected = id;
        if (interacted) {
          this.interacted = true;
          this.classList.add('has-interacted');
        }
        this.update();
        if (announce && changed && this.status) {
          const note = this.notes.find(item => item.dataset.frNote === id);
          this.status.textContent = note.textContent.replace(/\s+/g, ' ').trim();
        }
      }

      update() {
        const showAll = !this.enhanced || (this.mobile.matches && this.dataset.mobileBehavior === 'all');
        this.notes.forEach(note => {
          const active = note.dataset.frNote === this.selected;
          note.hidden = !showAll && !active;
          note.classList.toggle('is-active', active);
        });
        this.controls.forEach(control => control.setAttribute('aria-pressed', String(control.dataset.frSelect === this.selected)));
        this.guides.forEach(guide => guide.classList.toggle('is-active', guide.dataset.frGuide === this.selected));
        if (this.prompt) this.prompt.hidden = showAll || Boolean(this.selected);
      }

      onKeydown(event) {
        if (!this.enhanced || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        const control = event.target.closest('[data-fr-select]');
        const group = control?.closest('[data-fr-controls]');
        if (!group) return;
        const controls = [...group.querySelectorAll('[data-fr-select]')].filter(item => !item.hidden);
        if (group === this.rail) controls.sort((a, b) => Number(a.dataset.frequency) - Number(b.dataset.frequency));
        const current = controls.indexOf(control);
        if (current < 0) return;
        let next = current;
        const rtl = getComputedStyle(group).direction === 'rtl' && group === this.nav;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = controls.length - 1;
        else {
          let step = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
          if (rtl && ['ArrowLeft', 'ArrowRight'].includes(event.key)) step *= -1;
          next = (current + step + controls.length) % controls.length;
        }
        event.preventDefault();
        controls[next].focus({ preventScroll: true });
      }
    }
    customElements.define('epz-frequency-response', EPZFrequencyResponse);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
